"use client";

import BaseIndicatorConfig from "../common/BaseIndicatorConfig";

interface MovingAverageConfigProps {
  indicator: Parameters<typeof BaseIndicatorConfig>[0]["indicator"];
  onBack: () => void;
  onApply: (indicator: any) => void;
  isEditing?: boolean;
}

export default function MovingAverageConfig({
  indicator,
  onBack,
  onApply,
  isEditing,
}: MovingAverageConfigProps) {
  return (
    <BaseIndicatorConfig
      indicator={indicator}
      onBack={onBack}
      onApply={onApply}
      isEditing={isEditing}
      defaultExpandedStyle="ma"
    />
  );
}
